import type { OnboardingDiscipline } from "@shared/schema";

export const DISCIPLINE_LABELS: Record<OnboardingDiscipline, string> = {
  cx: "CX",
  comp_execs: "Comp Execs",
  growth: "Growth",
  gtm_engineering: "GTM Engineering",
  sales: "Sales",
  tech: "Tech",
  product: "Product",
  backoffice: "Backoffice",
};
